
<template>
  <div class="guide_body">
    <div class="body_top">
      <w-image :src="guideImg1" alt=" " class="guide1" @load="loadImg"></w-image>
    </div>
    <div v-show="showOtherImg">
      <div class="body_middle">
        <img src="~@/assets/images/enterprise/01.png"  alt=" " class="guide2">
        <img src="~@/assets/images/enterprise/02.png"  alt=" " class="guide3">
      </div>
      <div class="body_foot">
        <div class="guide_text">项目库升级后更名为项目数据快前往使用吧～</div>
        <img src="~@/assets/images/enterprise/guide4.png" alt=" " class="guide4">
        <w-button round type="primary" class="footer-button" @click="onClick">前往项目数据</w-button>
      </div>
    </div>
  </div>
</template>

<script>
import {dcostUrl} from "assets/js/config";
import {getCookie} from "utils/CommonUtil";

export default {
  name: 'Guide',
  data () {
    return {
      guideImg1: require('@/assets/images/enterprise/banner.png'),
      showOtherImg: false
    }
  },
  methods: {
    onClick () {
      let menuCode = 'dcost.module.data.wjgdk.gdsj'
      const token = getCookie('ZJYTOKEN')
      let url = `${dcostUrl}#/iframePortal?menuCode=${menuCode}&pageFrom=zjy&local_token=${token}`
      window.open(url)
    },
    loadImg () {
      // img1渲染时间长，统一控制下所有图片一起出现
      setTimeout(() => {
        this.showOtherImg = true
      }, 1)
    }
  }
}

</script>

<style scoped lang="less">
.guide_body {
  overflow: auto;
  height: 100%;
  width: calc(100% - 10px);
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  margin-bottom: 10px;
}
.guide_text {
  font-size: 18px;
  display: flex;
  align-items: center;
  padding-left: 40px;
  .span1 {
    width: 7px;
    height: 31px;
    border-radius: 548px;
    opacity: 1;
    background: #3886FA;
    margin-right: 4px;
  }
  .span2 {
    width: 7px;
    height: 18px;
    border-radius: 758px;
    opacity: 1;
    background: #34C5F7;
    margin-right: 20px;
  }
}
.guide1 {
  width: 100%;
}
.guide2,.guide3 {
  width: 687px;
  height: 200px;
}
.body_top {
  position: relative;
  padding-bottom: 10px;
}
.body_middle {
  overflow: hidden;
  display: flex;
  flex-direction: row;
  height: 200px;
  padding-top: 10px;
}
.body_foot {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  .guide4 {
    height: 36px;
    width: 23px;
    padding: 4px;
  }
}
.footer-button {
  width: 200px;
  height: 48px;
  border-radius: 202px;
  border-color: #4499FF;
  opacity: 1;
  background: #4499FF;
  font-size: 20px;
  padding: 10px;
  &:hover {
    border-color: #2288FF;
    background-color: #2288FF;
  }
}

</style>
